// Hook que carrega bairros + detecta CEP unico (heuristica: todos os
// bairros com mesmo CEP nao-vazio => CEP unico ativo). Refresh manual
// disponivel apos mutacoes.

import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { bairrosApi } from "../api/bairrosApi";

export function useBairrosData() {
  const [bairros, setBairros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cepUnico, setCepUnico] = useState(false);
  const [cepUnicoValue, setCepUnicoValue] = useState("");

  const detectarCepUnico = (lista) => {
    const comCep = lista.filter((b) => b.cep && b.cep.trim() !== "");
    if (comCep.length === 0 || lista.length === 0) {
      setCepUnico(false);
      setCepUnicoValue("");
      return;
    }
    const unicos = [...new Set(comCep.map((b) => b.cep))];
    if (unicos.length === 1 && comCep.length === lista.length) {
      setCepUnico(true);
      setCepUnicoValue(unicos[0]);
    } else {
      setCepUnico(false);
      setCepUnicoValue("");
    }
  };

  const refresh = useCallback(async () => {
    try {
      const { data } = await bairrosApi.listar();
      setBairros(data);
      detectarCepUnico(data);
    } catch (e) {
      console.error("[useBairrosData] erro:", e);
      toast.error("Erro ao carregar bairros");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { bairros, loading, refresh, cepUnico, cepUnicoValue, setCepUnico, setCepUnicoValue };
}
